import { PAGES, PAGES_PARSING } from "./constants";

export const normalizePreviewOrigin = (url?: string | null): string | undefined => {
  if (!url || typeof url !== "string") {
    return undefined;
  }
  return url.replace(/\/+$/, "");
};

export const resolvePreviewIframeOrigin = (
  whitelabelUrl?: string | null,
  customizationIframeOrigin?: string | null
): string | undefined =>
  normalizePreviewOrigin(whitelabelUrl) ||
  normalizePreviewOrigin(customizationIframeOrigin);

export const getPageFromSearchParam = (
  pageParam: string | null,
  usesExternalGivingPage = false
): string => {
  if (usesExternalGivingPage) {
    if (pageParam === "postdetail") {
      return PAGES.POST_DETAILS_PAGE;
    }
    return PAGES.NEWSFEED_PAGE;
  }
  if (pageParam === "giving") {
    return PAGES.GIVING_PAGE;
  }
  if (pageParam === "postdetail") {
    return PAGES.POST_DETAILS_PAGE;
  }
  return PAGES.NEWSFEED_PAGE;
};

export const buildPreviewIframeSrc = (
  origin: string | undefined,
  selectedPage: string
): string => {
  if (!origin) {
    return "";
  }
  const pagePath =
    PAGES_PARSING[selectedPage] ?? PAGES_PARSING[PAGES.NEWSFEED_PAGE];
  if (!pagePath) {
    return `${origin}?preview=true`;
  }
  if (pagePath.includes("?")) {
    return `${origin}/${pagePath}&preview=true`;
  }
  return `${origin}/${pagePath}?preview=true`;
};

export const pageParamFromSelectedPage = (selectedPage: string): string => {
  if (selectedPage === PAGES.GIVING_PAGE) {
    return "giving";
  }
  if (selectedPage === PAGES.POST_DETAILS_PAGE) {
    return "postdetail";
  }
  return "newsfeed";
};
